import { getAllUsers, getBookings, getServices } from "../../helpers/lib/axios";
import { useApiList } from "../../helpers/lib/useApiData";
import Section from "../Section";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";

const StatCard = ({ label, list, color }) => {
    const value = list.loading ? '…' : list.error ? '—' : list.items.length;
    return (
        <div className={`relative overflow-hidden rounded-xl ${color.bg} p-6`} title={list.error || undefined}>
            <div className={`absolute -right-6 -top-6 h-24 w-24 rounded-full ${color.circle} opacity-10`}></div>
            <div className="relative">
                <p className={`text-3xl font-bold ${color.text}`}>{value}</p>
                <p className="mt-1 text-sm text-gray-600">{label}</p>
            </div>
        </div>
    );
};

const Admin = () => {
    const users = useApiList(getAllUsers, 'Failed to load users.');
    const services = useApiList(getServices, 'Failed to load services.');
    const bookings = useApiList(getBookings, 'Failed to load bookings.');

    return (<>
        <BannerSectionStyle2
            bgUrl="/images/about/banner_bg.svg"
            imgUrl="/images/about/banner_img.png"
            title="Admin"
            subTitle="Admin Overview"
        />
        <Section
            topMd={170}
            topLg={150}
            topXl={110}
            bottomMd={200}
            bottomLg={150}
            bottomXl={110}
            className='flex justify-center items-center w-full'
        >
            <div className="lg:max-w-[70%] w-full mt-[5%] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
                <StatCard label="Total Users" list={users} color={{ bg: 'bg-blue-50', circle: 'bg-blue-500', text: 'text-blue-500' }} />
                <StatCard label="Total Services" list={services} color={{ bg: 'bg-green-50', circle: 'bg-green-500', text: 'text-green-500' }} />
                <StatCard label="Total Appointments" list={bookings} color={{ bg: 'bg-purple-50', circle: 'bg-purple-500', text: 'text-purple-500' }} />
            </div>
        </Section>
    </>);
}

export default Admin;
